import React from 'react';
import { Box, Card, CardContent } from '@mui/material';
import { IContract } from '../../../../../../types/contract';
import { ContractExtractionResult } from '../../../../../../types/aiOutput';
import { IDocument } from '../../../../../../types/document';
import ContractTimeline from '../../../../../components/ContractTimeline';

interface TimelineTabProps {
  contract: IContract;
  documents: IDocument[];
  aiOutputs: ContractExtractionResult[];
}

const TimelineTab: React.FC<TimelineTabProps> = ({
  contract,
  documents,
  aiOutputs,
}) => {
  return (
    <Box>
      <Card sx={{ width: '100%', display: 'flex' }}>
        <CardContent
          sx={{
            color: 'inherit',
            width: '100%',
          }}
        >
          <ContractTimeline
            contract={contract}
            documents={documents}
            aiOutputs={aiOutputs}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default TimelineTab;
